import { createContext, useContext } from 'react'
import { NavigationContextType } from './types'

const NavigationContext = createContext<NavigationContextType | undefined>(undefined)

export const useNavigation = () => {
  const context = useContext(NavigationContext)
  if (!context) throw new Error('useNavigation must be used within NavigationProvider')
  return context
}

export const NavigationProvider: React.FC<{ value: NavigationContextType; children: React.ReactNode }> = ({
  value,
  children
}) => <NavigationContext.Provider value={value}>{children}</NavigationContext.Provider>
